import React, { FunctionComponent } from 'react';
import styles from './side-nav-slider-item.module.scss';

export interface ISideNavSliderItemProps {
  text: string;
  index: number;
  isActive: boolean;
  changeItem: (event: React.MouseEvent<HTMLElement>) => void;
}

export const SideNavSliderItem: FunctionComponent<ISideNavSliderItemProps> = ({
  text,
  changeItem,
  index,
  isActive
}) => {
  return (
    <div
      className={`${styles.item} ${isActive && styles.active}`}
      data-index={index}
      onClick={changeItem}
    >
      <div className={styles.text}>{text}</div>
    </div>
  );
};
